module.exports = __webpack_public_path__ + "img/closebtn-icon.497cf447.svg";